import { z } from 'zod';

import { OptionEntity } from '@/types/OptionEntity';

export const newsDigestOptionSchema = z
  .object({
    id: z.union([z.string(), z.number()]),
    title: z.string().optional().nullable(),
    name: z.string().optional().nullable(),
  })
  .transform((raw) => {
    const id = Number(raw.id);
    const label = raw.title?.trim() || raw.name?.trim();

    const option: OptionEntity<string, string> = {
      key: id.toString(),
      value: label && label.length > 0 ? label : `Дайджест ${id}`,
    };

    return option;
  });

export type NewsDigestOption = OptionEntity<string, string>;
export type NewsDigestOptionApi = z.input<typeof newsDigestOptionSchema>;
